module.exports = ['$rootScope', '$state', '$stateParams', '$http', function ($scope, $state, $stateParams, $http) {
    var resultsLoaded = false;
    var lotKeyElement = document.getElementById('product-detail-v2').getAttribute("data-lotKey");
    var loadResults = function () {
        var lotKey = lotKeyElement ? lotKeyElement : '';
        $http.get('/api/Product?lotKey=' + lotKey)
            .then(function (res) {
                loading = false;
                initialLoad = true;
                angular.forEach(res.data.items, function (x, index) {
                    if (index < 3) {
                        $scope.results.push({
                            title: x.title,
                            image: x.image,
                            link: x.link,
                            content: x.content
                        });
                    }
                });
                if ($scope.results.length <= 0) {
                    document.getElementById("like-items-container").style.display = "none";
                }
            });

        resultsLoaded = true;
    };
    $scope.results = [];

    if (!resultsLoaded) {
        loadResults();
    };
}];